<gstar-grid
  dataIdKey="id"
  [source]="source.items"
  [totalCount]="source.total"
  [lazy]="true"
  [drawerSetting]="drawerSetting"
  [actionButtons]="actionButtons"
  [searchSetting]="searchSetting"
  [headers]="headers"
  [query]="query"
  (queryChange)="queryHandler($event)"
  [noDataFilteredMessage]="
    'admin.dashboard.notFoundRecordsMessage' | translate
  " />
